function getViewport() {

    let e: {[key: string]: number} = window as unknown as {[key: string]: number};

    let a = 'inner';

    if (!('innerWidth' in window )) {

        a = 'client';

        e = document.documentElement as unknown as {[key: string]: number} || document.body as unknown as {[key: string]: number};
    }
    return { width : e[ a + 'Width' ] , height : e[ a + 'Height' ] };
}

export function refineSizing() {

    const blocker = document.querySelector(".small-screen-blocker");

    const display = document.querySelector(".small-screen-blocker #screen-size-display");

    if (!blocker) {

        setTimeout(refineSizing, 125);
    }

    const viewport = getViewport();

    const height = viewport.height;

    const width = viewport.width;

    if (display) {

        display.innerHTML = `(${width}px&nbsp;&times;&nbsp;${height}px)`;
    }

    const fontSize = Math.min(16, Math.max(10, height / 768 * 16));

    (document.querySelector(":root") as HTMLElement).style.fontSize = fontSize + "px";

    let block = false;

    if (height < 480 || width < 768) {

        block = true;

    } else if (height > 615 && width < 992) {

        block = true;
    }

    if (block) {

        blocker?.classList?.remove('d-none');

        blocker?.classList?.add('d-flex');

    } else {

        blocker?.classList?.remove('d-flex');

        blocker?.classList?.add('d-none');
    }
}
